import React, { useContext, useRef, useState } from "react";

import { PropTypes } from "prop-types";

import { Grid } from "@mui/material";

import LoadingPage from "../../../react_utils/LoadingPage";
import { CustomButton } from "../../../react_utils/StyledElements";
import CustomModal from "../../../react_utils/modals/CustomModal";
import {
  string2Datetime,
  datetime2FormattedString,
} from "../../../shared/utils/utils";
import ClientLocationFormModal from "../clients/ClientLocationFormModal";
import Table from "../../../react_utils/table/Table";
import TablePagination from "../../../react_utils/table/TablePagination";
import { AuthContext } from "../../../shared/contexts/AuthContext";
import useAddClient from "../../../shared/hooks/location/useAddClient";

export const getAddClientModalOpenButton = (toggle) => {
  return (
    <CustomButton onClick={toggle} style={{ maxWidth: "300px" }} icon="device">
      Steuergerät hinzufügen
    </CustomButton>
  );
};

export default function AddClientModal({
  location,
  modalProps = {},
  resetParent,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const { user, apiClient } = useContext(AuthContext);
  const { pagination, clients } = useAddClient(apiClient, isFocused);

  const [chosenClient, setChosenClient] = useState(null);

  const modalRef = useRef(null);

  if (!user?.is_superuser) return null;

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    if (!isOpen) {
      setChosenClient(null);
    }
    modalProps.onToggle?.(isOpen);
  };

  return (
    <CustomModal
      title="Gerät wählen"
      {...modalProps}
      onToggle={onToggle}
      ref={modalRef}
    >
      {!clients ? <LoadingPage /> : null}
      <Grid container justify="center">
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
        >
          {clients ? (
            <Table
              columns={[
                { name: "Geräte-ID", key: "id" },
                { name: "Zuletzt online", key: "timestamp" },
              ]}
              rows={clients.map((client) => ({
                id: client.serial,
                timestamp: datetime2FormattedString(
                  string2Datetime(client.latest_query_timestamp),
                ),
                link: (row) => {
                  setChosenClient(client);
                },
              }))}
            />
          ) : null}
        </Grid>
        <Grid
          xs={12}
          sm={12}
          md={12}
          item
          display="flex"
          justifyContent="center"
          paddingTop={"10px"}
        >
          <TablePagination
            nPages={pagination.nPages}
            page={pagination.page}
            setPage={pagination.setPage}
          />
        </Grid>
      </Grid>
      <ClientLocationFormModal
        location={location}
        resetParent={() => {
          resetParent();
          modalRef.current?.toggle?.(false);
        }}
        client={chosenClient}
        modalProps={{
          isOpen: !!chosenClient,
          setIsOpen: (isOpen) => {
            if (!isOpen) setChosenClient(null);
          },
        }}
      />
    </CustomModal>
  );
}

AddClientModal.propTypes = {
  location: PropTypes.object,
  modalProps: PropTypes.object,
  resetParent: PropTypes.func,
};
